import { api, fetcher } from '@/lib/api';
import type {
  EmailNotificationListResponse,
  EmailNotificationQueryParams,
} from '@/types/api/notifications';

export const NOTIFICATION_DEFAULT_PAGE_SIZE = 10;

export const getEmailNotifications = async ({
  page = 1,
  per_page = NOTIFICATION_DEFAULT_PAGE_SIZE,
}: EmailNotificationQueryParams = {}): Promise<EmailNotificationListResponse> => {
  const params = new URLSearchParams();
  params.append('page', page.toString());
  params.append('per_page', per_page.toString());

  return fetcher<EmailNotificationListResponse>(
    `/email-notifications?${params.toString()}`
  );
};

export const markEmailNotificationOpened = async (id: number) => {
  return api.patch<{ success: boolean; data: { updated: number } }>(
    `/email-notifications/${id}/open`
  );
};
